// @flow
import React from 'react';
import { useParams } from 'react-router-dom';
import { getIn, useFormikContext } from 'formik';

import {
  DEFAULT_VALUE_FOR_DB_ROW_ID_STR,
  NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG,
} from '../../../constants';
import { ClusterInputTable } from '../../cluster/cluster-input-table/ClusterInputTable';
import { toastError } from '../../presentational/notifications/utils';
import { useUpdateNativeInferencePoolMutation } from '../../../service-definitions/estimates';
import { useEstimateVersion } from '../../../custom-hooks/useEstimateVersion';

const tokenBasedModelRowsConfig = [
  {
    backendName: 'is_enabled',
    displayName: 'Active',
    isBooleanField: true,
  },
  {
    backendName: 'input_tokens',
    displayName: 'Input Tokens (Millions)',
  },
  {
    backendName: 'output_tokens',
    displayName: 'Output Tokens (Millions)',
    // Embedding models don't produce output tokens, so spend on that line is always zero - hide it.
    showOrHideFunc: (values, contextData) =>
      !contextData?.modelName?.toLowerCase().includes('embed'),
  },
];

export const NativeInferencePoolTokenBasedModelMonthlyInputContainer = ({
  model,
  modelIndex,
  disabled,
}) => {
  const { estimateId, nativeInferencePoolId } = useParams();
  const [updateNativeInferencePool] = useUpdateNativeInferencePoolMutation();
  const estimateVersion = useEstimateVersion();
  const { values } = useFormikContext();

  const modelLabel = model.modelLabel;
  const keyNameInValuesToUseForThisModel = `${NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG}.models[${modelIndex}]`;

  return (
    <ClusterInputTable
      contextData={{ modelName: model.modelName }}
      disabled={disabled}
      isNewElemAddedByUI={model.modelId === DEFAULT_VALUE_FOR_DB_ROW_ID_STR}
      keyNameInValues={keyNameInValuesToUseForThisModel}
      rowsConfig={tokenBasedModelRowsConfig}
      tableName={`Monthly Usage for ${modelLabel}`}
      updateFunc={async () => {
        const modelValues = getIn(values, keyNameInValuesToUseForThisModel);

        const payload = {
          id: nativeInferencePoolId,
          estimate_id: estimateId,
          estimate_version: estimateVersion,
          models: [
            {
              model_id:
                modelValues.modelId === DEFAULT_VALUE_FOR_DB_ROW_ID_STR
                  ? undefined
                  : modelValues.modelId,
              name: modelValues.modelName,
              inputs: Object.values(modelValues.months),
            },
          ],
        };

        const { error } = await updateNativeInferencePool({
          estimateId,
          nativeInferencePoolId,
          payload,
        });

        if (error) {
          toastError(error);
        }
      }}
    />
  );
};
